import React from 'react';

import chevronDownImg from '../../static/img/toggledown.svg';
import chevronUpImg from '../../static/img/arrowup2.svg';
import studentsIcon from '../../static/icons/Students-icon.svg';
import purpleFilterIcon from '../../static/icons/purple-filter.svg';
import purpleSettings from '../../static/icons/PurpleSettingIcon.svg';
import expandIconSrc from '../../static/icons/expand-icon.svg';
import closeIconSrc from '../../static/img/FAClose.svg';
import calendarNew from '../../static/img/Calendar-new.svg';
import columnsNew from '../../static/img/Columns-new.svg';
import menuNavIcon from '../../static/icons/Menu-nav-icon.svg';
import rubricIconSrc from '../../static/icons/black-rubric-icon.svg';
import downloadIconSrc from '../../static/img/Download.svg';

export const ClockIcon = (props) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="ci-time-saved-icon"
    {...props}
  >
    <g id="clock" clipPath="url(#clip0_2567_6474)">
      <path
        id="Vector"
        d="M15.3333 8.66667C15.3333 12.3467 12.3467 15.3333 8.66667 15.3333C4.98667 15.3333 2 12.3467 2 8.66667C2 4.98667 4.98667 2 8.66667 2C12.3467 2 15.3333 4.98667 15.3333 8.66667Z"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M11.1399 10.7867L9.07325 9.55334C8.71325 9.34001 8.41992 8.82667 8.41992 8.40667V5.67334"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2567_6474">
        <rect width="16" height="16" fill="white" transform="translate(0.666992 0.666504)" />
      </clipPath>
    </defs>
  </svg>
);

export const ChevronDown = (props) => (
  <img src={chevronDownImg} alt="" className="ci-chip-arrow" {...props} />
);

export const ChevronUp = (props) => (
  <img src={chevronUpImg} alt="" className="ci-chip-arrow" {...props} />
);

export const UsersIcon = (props) => (
  <img src={studentsIcon} alt="" className="ci-chip-icon" {...props} />
);

export const FilterIcon = (props) => (
  <img src={purpleFilterIcon} alt="" className="ci-chip-icon" {...props} />
);

export const SettingsIcon = (props) => (
  <img src={purpleSettings} alt="" className="ci-chip-icon" {...props} />
);

export const ExpandIcon = (props) => (
  <img src={expandIconSrc} alt="" className="ci-expand-icon" {...props} />
);

export const CloseIcon = (props) => (
  <img src={closeIconSrc} alt="" width={24} height={24} {...props} />
);

export const CalendarIcon = (props) => (
  <img src={calendarNew} alt="" className="ci-calendar-icon" {...props} />
);

export const GridIcon = (props) => (
  <img src={columnsNew} alt="" className="ci-grid-list-icon" {...props} />
);

export const ListIcon = (props) => (
  <img src={menuNavIcon} alt="" className="ci-grid-list-icon" {...props} />
);

export const RubricIcon = (props) => (
  <img src={rubricIconSrc} alt="" className="ci-chip-icon" {...props} />
);

export const DownloadIcon = (props) => (
  <img src={downloadIconSrc} alt="" {...props} />
);
